import React from "react"
import { formatDate } from "@ui-seeker/utils"
import { validateFormat } from "@utils"
import { Box, Typography } from "@mui/material"

export default function categoryColumn(label) {
	return [{
		name: 'nameFilter', label: label?.replace('-', ' ').toUpperCase(),
		options: { display: 'excluded' }
	},
		{
			name: 'name',
			label: label?.replace('-', ' ').toUpperCase(),
			options: {
				filter: false,
				setCellHeaderProps: () => ({
					sx: {
						position: 'sticky',
						top: 0,
						left: 0,
						zIndex: '150 !important',
					}
				}),
				setCellProps: (_, idx) => {
					return {
						sx: {
							position: "sticky",
							backgroundColor: idx % 2 === 0 ? "background.grey" : "background.lightGrey",
							top: 0,
							left: 0,
							zIndex: 3,
						}
					}
				},
				customBodyRowRenderLite: (value) => {
					if (label === "booking-pickup" && validateFormat('yyyyMMdd', value)) return formatDate(value, {
						formatReceived: 'yyyyMMdd',
						isString: true
					})
					return <Box>
						<Typography>{value}</Typography>
					</Box>
				}
			}
		}
	]
}